export default __webpack_public_path__ + "static/media/enderima2.6660fa27.jpg";